import { render } from "./ProductRemainsDetail.vue?vue&type=template&id=3c29ce14&scoped=true"
import script from "./ProductRemainsDetail.vue?vue&type=script&lang=js"
export * from "./ProductRemainsDetail.vue?vue&type=script&lang=js"

import "./ProductRemainsDetail.vue?vue&type=style&index=0&id=3c29ce14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c29ce14"]])

export default __exports__